/**
 * MyChampionshipsPage — Standalone page "Meus Campeonatos"
 * 
 * Accessible from GlobalSidebar for ATLETA, TREINADOR and GESTOR roles.
 * Reuses MyChampionshipsSection (same component used in SocialProfilePage).
 * Context comes from ActiveContextContext (sport, club, entity).
 */
import React from 'react';
import { useActiveContext } from '../contexts/ActiveContextContext';
import { useSport } from '../contexts/SportContext';
import { useRBAC } from '../contexts/RBACContext';
import MyChampionshipsSection from '../components/championships/MyChampionshipsSection';
import PageHeader from '../components/layout/PageHeader';
import { Trophy } from 'lucide-react';
import { BRAND_GREEN } from '../theme/sucronTheme';

const MyChampionshipsPage = () => {
  const { activeSport } = useSport();
  const { activeRole } = useRBAC();
  const {
    clubId, clubName,
    entityId, entityType, entityName,
  } = useActiveContext();

  // Role label for subtitle
  const roleLabel = {
    ATLETA: 'Atleta',
    TREINADOR: 'Treinador',
    GESTOR: 'Gestor',
  }[activeRole] || activeRole;

  const sportLabel = activeSport === 'football' ? 'Futebol' : activeSport === 'swimming' ? 'Natação' : activeSport || '—';

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f9fafb' }}>
      <div className="max-w-4xl mx-auto px-4 lg:px-6 py-6 space-y-6">

        {/* Header */}
        <PageHeader
          title="Meus Campeonatos"
          subtitle={
            clubName
              ? `${roleLabel} • ${clubName} • ${sportLabel}`
              : 'Selecione um contexto ativo para ver seus campeonatos'
          }
          badgeText={activeSport ? sportLabel : null}
          badgeIcon={<Trophy size={12} />}
        />

        {/* Context Summary (mini) */}
        {clubId && entityName && (
          <div className="flex items-center gap-3 px-4 py-3 bg-white rounded-xl border border-gray-200 text-sm">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: BRAND_GREEN + '15' }}>
              <Trophy size={16} style={{ color: BRAND_GREEN }} />
            </div>
            <div>
              <span className="text-gray-500">Contexto: </span>
              <strong className="text-gray-900">{entityName}</strong>
              <span className="text-gray-400"> @ {clubName}</span>
            </div>
          </div>
        )}

        {/* Main Content — reuses the same component from Profile */}
        <MyChampionshipsSection
          sport={activeSport}
          clubId={clubId}
          entityType={entityType}
          entityId={entityId}
        />
      </div>
    </div>
  );
};

export default MyChampionshipsPage;
